import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { AreaEditService } from '../../service/area-edit/area-edit.service';

@Component({
	selector: 'app-area-edit',
	templateUrl: './area-edit.component.html',
	providers: [
		AreaEditService,
		HttpModule
	]
})
export class AreaEditComponent implements OnInit {

	private token;
	private sub: any;
	area: FormGroup;
	ID: string;
	Nome: string;
	Ativo: boolean;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private areaEditService: AreaEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.area = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.areaEditService.loadArea(this.token, this.ID).subscribe(result => {
				var updateArea = result.Result;
				this.area.setValue({
					ID: updateArea.ID,
					Nome: updateArea.Nome,
					Ativo: updateArea.Ativo
				});
			})
		}, error => {
			console.log(error);
			
		});
	}

	editArea(value: any) {
		this.areaEditService.editArea(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Área Irrigada editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/area');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/area');
	}

}



// WEBPACK FOOTER //
// ./src/app/area/component/area-edit/area-edit.component.ts